<mat-card>
  <h1 class="mat-display-1 smallmargin">
    Cheatsheets
  </h1>
  <p class="mat-body">
    This page has moved to the <a href="https://avrae.readthedocs.io/en/stable/" target="_blank"
                                  rel="noopener noreferrer">new Cheatsheet site.</a>
  </p>
</mat-card>
